module.exports = __webpack_public_path__ + "img/white-header-2.dac4f539.png";